export default class HomeController {
  constructor($scope, $rootScope, $filter, $timeout, CurrentCase, CurrentUser,
    $location, $compile, $parse, $uibModal, $routeParams, $window, $q,
    $templateCache, IssuesModalConf, SourcesModalConf, TagsModalConf,
    ContributorsModalConf, DeleteFactModalConf, FactModalConf, ExportServ,
    FactQuery, FactList, Groupings, Fact, ArchiveCaseModalConf) {

    this.scope = $scope;
    this.location = $location
    this.export = ExportServ.export;
    this.window = $window;
    this.filterDate = $filter('date');
    this.groupings = Groupings;

    this.currentCase = CurrentCase;
    this.factQuery = FactQuery;
    this.factQuery.subscribe(() => {
      if (this.factQuery.data.filterPipeline) {
        this.viewBy = this.factQuery.data.filterPipeline
          .filter(f => f.attribute !== 'keywords')[0];
        this.orderBy = this.factQuery.data.orderBy[0];
      }
      if (this.factQuery.data.columns) {
        this.groupings[this.viewBy.attribute].columnsByGroup.forEach(attr => {
          attr.visible =
            this.factQuery.data.columns.indexOf(attr.key) >= 0
        })
      }
      // Ensure a default is set
      if (!this.factQuery.data.format) {
        this.factQuery.data.format = 'table';
      }
      if (!this.orderBy) {
        this.orderBy = {
          attribute: 'factDateish'
        };
      }
      this.hiddenFacts = this.factQuery.data.hidden;
    })

    this.factList = FactList;
    this.factModel = Fact;

    this.modalConf = {
      issues: IssuesModalConf,
      sources: SourcesModalConf,
      tags: TagsModalConf,
      contributors: ContributorsModalConf,
      deleteFact: DeleteFactModalConf,
      fact: FactModalConf,
      archiveCase: ArchiveCaseModalConf
    };
    this.emptyAttrText = {
      factDateish: 'Add a fact with a date',
      sources: 'Add a source',
      legalIssues: 'Add an issue',
      tags: 'Add a tag',
      contributors: 'Add a contributor',
      content: 'Add a fact with content',
      title: 'Add a fact with a title'
    }
    this.openModal = $uibModal.open;
    this.currentDate = $filter('date')(new Date(), 'longDate')

    // this.sourcesModal()

  }
  setCaseName(newValue) {
    this.currentCase.setProp('displayName', newValue)
    return this.currentCase.api.update()
  }
  archiveCase() {
    this.openModal(this.modalConf.archiveCase).result.then(() => {
      this.currentCase.setProp('status', 'archived')
      this.currentCase.api.update().then(() => {
        this.location.search('finalDestination', true)
        this.location.path('/home')
      })
    })
  }
  toggleCases() {
    this.scope.$broadcast('displayCases');
  }
  caseModal() {
    this.scope.caseModal();
  }
  selectRow(item, index) {
    if (!item.row) {
      return;
    } else if (this.selectedRow &&
      this.selectedRow.row === item.row &&
      this.selectedRow.index === index
    ) {
      this.deselectRow();
      return;
    }
    this.selectedRow = item;
    this.selectedRow.index = index;
  }
  deselectRow() {
    this.selectedRow = {};
  }
  editRow(item) {
    if (!item.row || this.scope.isVisitor) {
      return;
    }
    this.selectedRow = item;
    this.openModal(angular.extend(this.modalConf.fact, {
      resolve: {
        isFactWindow: () => false,
        currentFact: () => this.selectedRow.row
      }
    })).result.then(() => {
      this.factList.reload(item.index)
    });
  }
  deleteRow(item) {
    if (!item.row || this.scope.isVisitor) {
      return;
    }
    var factModel = new this.factModel(item.row);

    factModel.api.delete().then(() => {
      // delete from fact list
    }, response => {
      if (response.status === 412) {
        this.openModal(this.modalConf.deleteFact).result.then(() => {
          factModel.api.delete().then(() => {
            this.factList.removeFact(item.row);
            this.deselectRow();
          })
        })

      }
    })
  }
  updateQuery(key, value) {
    this.factQuery.data[key] = value;
    this.factQuery.api.update();
  }
  setSorting(key, order) {
    if (!this.groupings[key].secondarySortable) {
      return;
    }
    this.orderBy.attribute = key;
    this.orderBy.order = order;
    this.factQuery.data.orderBy[0] = this.orderBy
    this.factQuery.api.update();
  }
  toggleSorting(key) {
    var order = this.orderBy.attribute === key ? {
      desc: 'asc',
      asc: 'desc'
    }[this.orderBy.order] : this.orderBy.order;

    this.setSorting(key, order);
  }
  toggleColumn(column) {
    var getCols = () => this.groupings[this.viewBy.attribute].columnsByGroup.filter(
      col => col.visible
    );
    // don't allow the last column to be hidden
    if (getCols().length + (column.visible ? -1 : 1) <= 0) {
      return;
    }
    column.visible = !column.visible;

    var sortableCols = getCols().map(
      col => this.groupings[col.key]
    ).filter(
      col => col.secondarySortable
    ).map(
      col => col.key
    );

    if (sortableCols.length === 0) {
      this.orderBy.attribute = this.viewBy.attribute;
    } else if (sortableCols.indexOf(this.orderBy.attribute) === -1 ||
      this.orderBy.attribute === this.viewBy.attribute) {
      this.orderBy.attribute = sortableCols[0];
    }

    this.factQuery.data.columns = getCols().map(col => col.key);
    this.factQuery.data.orderBy[0] = this.orderBy;
    this.factQuery.api.update();
  }
  openAddFact(id = '') {
    // Sets the name of the current window for Add Fact windows to reference
    this.window.name = 'FactBox';
    let url = `#/fact/${this.currentCase.data.id || id}`
    if (this.scope.guideEnabled) {
      url += '?action-guide=true';
    }
    this.window.open(url,
      '_blank',
      'height=448,width=672,status=no,scrollbars=no, resizable=yes');
  }
  issuesModal() {
    this.openModal(this.modalConf.issues)
      .result.then(() => this.currentCase.api.get(), () => this.currentCase.api
        .get());
  }
  sourcesModal() {
    this.openModal(this.modalConf.sources)
      .result.then(() => this.currentCase.api.get(), () => this.currentCase.api
        .get());
  }
  tagsModal() {
    this.openModal(this.modalConf.tags)
      .result.then(() => this.currentCase.api.get(), () => this.currentCase.api
        .get());
  }
  contributorsModal() {
    this.openModal(this.modalConf.contributors)
      .result.then(() => this.currentCase.api.get(), () => this.currentCase.api
        .get());
  }
  deleteFactModal() {
    this.openModal(this.modalConf.deleteFact)
      .result.then(() => this.currentCase.api.get(), () => this.currentCase.api
        .get());
  }

  hideRow(item) {
    if (!item.row) {
      return;
    }
    if (this.hiddenFacts.indexOf(item.row.id) === -1) {
      this.hiddenFacts.push(item.row.id);
      this.factList.removeFact(item.row);
      this.deselectRow();
      this.updateQuery('hidden', this.hiddenFacts);
    }
  };

  unhideFacts() {
    this.hiddenFacts = [];
    this.updateQuery('hidden', this.hiddenFacts);
  };
};

HomeController.$inject = ['$scope', '$rootScope', '$filter', '$timeout',
  'CurrentCase', 'CurrentUser', '$location', '$compile', '$parse',
  '$uibModal', '$routeParams', '$window', '$q', '$templateCache',
  'IssuesModalConf', 'SourcesModalConf', 'TagsModalConf',
  'ContributorsModalConf', 'DeleteFactModalConf', 'FactModalConf',
  'ExportServ', 'FactQuery', 'FactList', 'Groupings', 'Fact',
  'ArchiveCaseModalConf'
];



// WEBPACK FOOTER //
// ./project/pages/home/home.controller.js